import { render } from "./WelcomeDashboard.vue?vue&type=template&id=58ec4dce&ts=true"
import script from "./WelcomeDashboard.vue?vue&type=script&lang=ts"
export * from "./WelcomeDashboard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__